// extracted by mini-css-extract-plugin
export var content = "style-module--content--79ec7";
export var image = "style-module--image--e4d5d";
export var wrapper = "style-module--wrapper--ba566";